import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Invoice } from 'src/app/interfaces/stripe/invoice.interface';

@Component({
    selector: 'app-stripe-chargehistory-table',
    templateUrl: './stripe-chargehistory-table.component.html',
    styleUrls: ['./stripe-chargehistory-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StripeChargehistoryTableComponent {
    @Input() invoices: Invoice[] = [];

  settlementLabel(action: string): string {
    const labels: Record<string, string> = {
      credited: 'Credited', pending: 'Credit pending', refunded: 'Refunded',
      skipped: 'Not credited', failed: 'Credit failed', error: 'Credit failed',
      refundedRemovedMember: 'Refunded — member removed',
    };
    return labels[action] || 'Credit status unavailable';
  }

  expandCollapse(charge: any): void {
    charge.expanded = !charge.expanded;
  }

  openInvoice(url: any): void {
    window.open(url);
  }

}
